/**
 * Author: postcodex
 * Date: 2018/08/23
 * Time: 1:57 PM
 */
import { all } from 'redux-saga/effects';
import { watchSearchAddresses } from './app';

export default function* rootSaga() {
	yield all( [
		watchSearchAddresses()
	] );
}
